import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const TourList = ({ universityId, onEdit, refreshKey }) => {
    const [tours, setTours] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        setIsLoading(true);
        
        const token = localStorage.getItem('token');
        
        fetch(`${apiUrl}/tours/${universityId}/upcoming`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch tours");
                }
                return response.json();
            })
            .then((data) => {
                console.log("API Response:", data); // Debugging log
                setTours(Array.isArray(data) ? data : []); // Ensure it's an array
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching tours:", error);
                setError("Failed to load tours. Please try again.");
                setTours([]); // Ensure tours is never undefined or null
                setIsLoading(false);
            });
    }, [universityId, refreshKey]);

    if (isLoading) {
        return <p>Loading tours...</p>;
    }

    return (
        <section className="recent-tours">
            <h4>Upcoming Tours</h4>
            <hr />

            {error ? (
                <p className="text-danger">{error}</p>
            ) : tours.length === 0 ? (
                <p>No upcoming tours available for this university.</p>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>TOUR NAME</th>
                            <th>TOUR DATE</th>
                            <th>CREATED DATE</th>
                            <th>CREATED BY</th>
                            <th>LAST UPDATED</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tours.map((tour) => (
                            <tr key={tour.id}>
                                <td>
                                    {tour.name} ({tour.country || "No Country"})
                                </td>
                                <td>
                                    {tour.date_from
                                        ? new Date(tour.date_from).toLocaleDateString("en-US")
                                        : "No Date"}{" "}
                                    -{" "}
                                    {tour.date_to
                                        ? new Date(tour.date_to).toLocaleDateString("en-US")
                                        : "No Date"}
                                </td>
                                <td>
                                    {tour.created_on
                                        ? new Date(tour.created_on).toLocaleDateString("en-US")
                                        : "No Date"}
                                </td>
                                <td>{tour.created_by}</td>
                                <td>
                                    {tour.last_updated
                                        ? new Date(tour.last_updated).toLocaleDateString("en-US")
                                        : "No Date"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </section>
    );
};

export default TourList;